'use client';
import React, { useState } from 'react';
import Typography from '@/components/atoms/typography';
import CreateProfile from '@/components/organisms/create-profile';


const CreateProfileTastic = () => {
    return <CreateProfile />;
};

export default CreateProfileTastic;

